import { Page } from '@/types'
import React from 'react'
import { LessonStore } from './store'
import { onPreloadImages } from './utils'
import { Origin } from './types'

type ILessonContext = {
  inSwipe: React.MutableRefObject<boolean>
  pages?: Page[]
  origin: Origin
  pagesLength: number
  lastIndex: number
  initialPage: number
}

export const LessonContext = React.createContext({} as ILessonContext)

type ProviderProps = React.PropsWithChildren<{
  initialPage?: number
  origin?: Origin
}>

export const LessonContextProvider = (props: ProviderProps) => {
  const { children, initialPage, origin = 'learn' } = props

  const _pages = LessonStore.use(s => s.pages)

  onPreloadImages(_pages)

  const inSwipe = React.useRef(false)

  const pages = React.useMemo(() => {
    if (!_pages?.length) return []
    return [...(origin === 'feed' ? [] : [{ id: 'start' } as Page]), ..._pages]
  }, [_pages, origin])

  const pagesLength = pages.length
  const lastIndex = pagesLength - 1

  const value: ILessonContext = {
    inSwipe,
    pages,
    origin,
    pagesLength,
    lastIndex,
    initialPage,
  }

  return <LessonContext.Provider value={value}>{children}</LessonContext.Provider>
}

export function useLessonContext() {
  const context = React.useContext(LessonContext)
  if (!context) throw new Error('useLessonContext must be used inside LearnProvider')
  return context
}
